/**
 * The card treatment shared by every floating map panel: the workspace
 * callouts, the onboarding card and the armed-tool panel shell owned by
 * MapToolbox.
 *
 * These hex values come from the SpotOn Claude Design mockup (`--panel-soft`
 * border + soft drop shadow). They have no equivalent in the app's Tailwind
 * theme — `border-primary-100` is a visibly different green-grey — so the exact
 * design values are kept, centralised here instead of copied per panel.
 *
 * Corner radius stays at the call site: the corner callouts share the corner
 * cards' `rounded-[10px]` while the onboarding card is `rounded-xl`.
 */
export const MAP_PANEL_SURFACE =
  'border border-[#e6e9e8] bg-white shadow-[0_4px_8px_rgba(0,0,0,0.15)]';
